import { createContext, useContext } from 'react'

interface GuideSidebarContextType {
  open: boolean
  setOpen: (open: boolean) => void
}

export const GuideSidebarContext = createContext<GuideSidebarContextType | null>(null)

export function useGuideSidebarContext() {
  const context = useContext(GuideSidebarContext)
  if (!context) {
    throw new Error('useGuideSidebarContext must be used within a GuideSidebarProvider')
  }
  return context
}
